if (!customElements.get('category-carousel')) {
    customElements.define(
      'category-carousel',
      class CategoryCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.category-carousel__track');
          this.previousButton = this.querySelector('[data-previous]');
          this.nextButton = this.querySelector('[data-next]');
          this.controls = this.querySelector('[data-controls]');

          if (!this.track || !this.previousButton || !this.nextButton || !this.controls) return;

          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
          window.addEventListener('resize', () => this.requestUpdate());

          /*
            Deferred to the next frame deliberately. updateControls() reads
            scrollWidth and clientWidth, which forces a synchronous layout.
            Called directly here it would do that inside the theme's deferred
            script batch, alongside the other carousels on the page, which is
            a measurable slice of Total Blocking Time on first load.
            requestUpdate() runs the same call inside requestAnimationFrame,
            so it reads after layout has settled rather than forcing it.
          */
          this.requestUpdate();
        }

        getScrollStep() {
          const firstItem = this.track.querySelector('.category-carousel__item');
          if (!firstItem) return this.track.clientWidth;

          const trackStyles = window.getComputedStyle(this.track);
          const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
          return firstItem.getBoundingClientRect().width + gap;
        }

        move(direction) {
          this.track.scrollBy({ left: this.getScrollStep() * direction, behavior: 'smooth' });
        }

        requestUpdate() {
          window.cancelAnimationFrame(this.updateFrame);
          this.updateFrame = window.requestAnimationFrame(() => this.updateControls());
        }

        updateControls() {
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const hasOverflow = maxScroll > 2;

          this.controls.hidden = !hasOverflow;
          this.previousButton.disabled = !hasOverflow || this.track.scrollLeft <= 2;
          this.nextButton.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }
